import { render } from "./MyAccount.vue?vue&type=template&id=a6fdda0a"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__